"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ApiDocsService", {
    enumerable: true,
    get: function() {
        return ApiDocsService;
    }
});
const _common = require("@nestjs/common");
const _getSwaggerJSON = /*#__PURE__*/ _interop_require_default(require("./swagger/getSwaggerJSON"));
const _getSwaggerJSONV2 = /*#__PURE__*/ _interop_require_default(require("./swaggerV2/getSwaggerJSONV2"));
const _getSwaggerJSONV3 = /*#__PURE__*/ _interop_require_default(require("./swaggerV3/getSwaggerJSONV3"));
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _tableHelpers = require("~/helpers/tableHelpers");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let ApiDocsService = class ApiDocsService {
    async swaggerJson(context, param) {
        const base = await _models.Base.get(context, param.baseId);
        if (!base) _catchError.NcError.baseNotFound(param.baseId);
        const models = await this.extractVisibleModels(context, param);
        // Fetch sources once for the entire base to avoid repeated queries
        const sources = await base.getSources(false);
        const sourcesMap = new Map(sources.map((source)=>[
                source.id,
                source
            ]));
        const swagger = await (0, _getSwaggerJSON.default)(context, {
            sourcesMap,
            base,
            models
        });
        swagger.servers = [
            {
                url: param.siteUrl
            },
            {
                url: '{customUrl}',
                variables: {
                    customUrl: {
                        default: param.siteUrl,
                        description: 'Provide custom nocodb app base url'
                    }
                }
            }
        ];
        return swagger;
    }
    async extractVisibleModels(context, param) {
        const allModels = await _models.Model.list(context, {
            base_id: param.baseId,
            source_id: null
        });
        const models = [];
        // filter based on table visibility permission
        Promise.all(allModels.map(async (model)=>{
            var _param_req;
            if (await (0, _tableHelpers.hasTableVisibilityAccess)(context, model.id, (_param_req = param.req) == null ? void 0 : _param_req.user)) {
                models.push(model);
            }
        }));
        return models;
    }
    async swaggerJsonV2(context, param) {
        const base = await _models.Base.get(context, param.baseId);
        if (!base) _catchError.NcError.baseNotFound(param.baseId);
        const models = await this.extractVisibleModels(context, param);
        // Fetch sources once for the entire base to avoid repeated queries
        const sources = await base.getSources(false);
        const sourcesMap = new Map(sources.map((source)=>[
                source.id,
                source
            ]));
        const swagger = await (0, _getSwaggerJSONV2.default)(context, {
            sourcesMap,
            base,
            models
        });
        swagger.servers = [
            {
                url: param.siteUrl
            },
            {
                url: '{customUrl}',
                variables: {
                    customUrl: {
                        default: param.siteUrl,
                        description: 'Provide custom nocodb app base url'
                    }
                }
            }
        ];
        return swagger;
    }
    async swaggerJsonV3(context, param) {
        const base = await _models.Base.get(context, param.baseId);
        if (!base) _catchError.NcError.baseNotFound(param.baseId);
        const models = await this.extractVisibleModels(context, param);
        // Fetch sources once for the entire base to avoid repeated queries
        const sources = await base.getSources(false);
        const sourcesMap = new Map(sources.map((source)=>[
                source.id,
                source
            ]));
        const swagger = await (0, _getSwaggerJSONV3.default)(context, {
            sourcesMap,
            base,
            models
        });
        swagger.servers = [
            {
                url: param.siteUrl
            },
            {
                url: '{customUrl}',
                variables: {
                    customUrl: {
                        default: param.siteUrl,
                        description: 'Provide custom nocodb app base url'
                    }
                }
            }
        ];
        return swagger;
    }
};
ApiDocsService = _ts_decorate([
    (0, _common.Injectable)()
], ApiDocsService);
